import React from "react";
import searchIcon from "../../../assets/searchIcon.png";
import "../AdminDashBoard.css";
import { TableContent } from "./data";

const index = () => {
  return (
    <div className="row">
      <div className="col-md-1"></div>
      {/* <!-- Users --> */}
      <div className="col-11 TableMax-width mx-auto mt-5 pt-md-5 marginTop10">
        <div className="row">
          <div className="col-md-12">
            <h2 className="TableHeading">Users</h2>
          </div>
          <div className="col-md-12">
            {/* <!-- Tabs --> */}
            <div className="TabWrapper TabWrap_Noradius">
              <ul className="mb-3 StashTabs_Link">
                <ul
                  className="left_SLink nav nav-pills"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="active"
                      id="pills-user1-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-user1"
                      type="button"
                      role="tab"
                      aria-controls="pills-user1"
                      aria-selected="true"
                    >
                      Admins
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className=""
                      id="pills-user2-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-user2"
                      type="button"
                      role="tab"
                      aria-controls="pills-user2"
                      aria-selected="false"
                    >
                      Creators
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className=""
                      id="pills-user3-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-user3"
                      type="button"
                      role="tab"
                      aria-controls="pills-user3"
                      aria-selected="false"
                    >
                      Standard User
                    </button>
                  </li>
                </ul>
                <ul className="Right_SLink">
                  <li className="me-4 InputWrapper">
                    <input
                      type="text"
                      placeholder="Search"
                      className="Right_SLinkInput"
                    />
                    <span className="Right_SLinkSelectWrapper">
                      <select name="" id="" className="Right_SLinkSelect">
                        <option value="">Category</option>
                        <option value="">Category</option>
                      </select>
                    </span>
                    <button className="Right_SLinkBtn">
                      <img src={searchIcon} className="img-fluid" alt="" />
                    </button>
                  </li>
                  <li>
                    <span className="CreateBtnWraper">
                      <select name="" id="" className="CreateBtn">
                        <option value="">Sort</option>
                        <option value="">Start3</option>
                        <option value="">Start4</option>
                      </select>
                    </span>
                    {/* <!-- <button className="CreateBtn">
                    <span> Create Drop</span>
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </button> --> */}
                  </li>
                </ul>
              </ul>
              <div
                className="tab-content StashTabs_Content"
                id="pills-tabContent"
              >
                {/* <!-- 1 Tabs --> */}
                <div
                  className="tab-pane fade show active"
                  id="pills-user1"
                  role="tabpanel"
                  aria-labelledby="pills-user1-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col-3">
                        <span className="">Name</span>
                      </div>
                      <div className="col">
                        <span>User Type</span>
                      </div>
                      <div className="col-2">
                        <span>Email address</span>
                      </div>
                      <div className="col">
                        <span>Twitter Handle</span>
                      </div>
                      <div className="col">
                        <span>Instagram Handle</span>
                      </div>
                      <div className="col">
                        <span>Total NFT Content</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    const UserImg = require(`../../../assets/${item.PersonImg}`);
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-3">
                            <img
                              src={UserImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <p className="mb-0 d-flex flex-column">
                              <span className="img-txt1">{item.FirstName}</span>
                              <span>{item.LastName}</span>
                            </p>
                          </div>
                          <div className="col">
                            <span>{item.Usertype}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.Email}</span>
                          </div>
                          <div className="col">
                            <span>{item.Twitter}</span>
                          </div>
                          <div className="col">
                            <span>{item.Insta}</span>
                          </div>
                          <div className="col">
                            <span>{item.TotalNFT}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- 2 Tabs --> */}
                <div
                  className="tab-pane fade"
                  id="pills-user2"
                  role="tabpanel"
                  aria-labelledby="pills-user2-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col-2">
                        <span className="">Artist Handle</span>
                      </div>
                      <div className="col-3">
                        <span>Name of Stash Drop </span>
                      </div>
                      <div className="col">
                        <span>Stash Season </span>
                      </div>
                      <div className="col-2">
                        <span>Date & Time (PST) </span>
                      </div>
                      <div className="col">
                        <span>Edition NFT Mint Price </span>
                      </div>
                      <div className="col">
                        <span>Number of NFT Editions </span>
                      </div>
                      <div className="col-1">
                        <span>Options</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    const UserImg = require(`../../../assets/${item.PersonImg}`);
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-3">
                            <img
                              src={UserImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <p className="mb-0 d-flex flex-column">
                              <span className="img-txt1">{item.FirstName}</span>
                              <span>{item.LastName}</span>
                            </p>
                          </div>
                          <div className="col">
                            <span>{item.Usertype}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.Email}</span>
                          </div>
                          <div className="col">
                            <span>{item.Twitter}</span>
                          </div>
                          <div className="col">
                            <span>{item.Insta}</span>
                          </div>
                          <div className="col">
                            <span>{item.TotalNFT}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- 3 Tabs --> */}
                <div
                  className="tab-pane fade"
                  id="pills-user3"
                  role="tabpanel"
                  aria-labelledby="pills-user3-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col-2">
                        <span className="">Artist Handle</span>
                      </div>
                      <div className="col-3">
                        <span>Name of Stash Drop </span>
                      </div>
                      <div className="col">
                        <span>Stash Season </span>
                      </div>
                      <div className="col-2">
                        <span>Date & Time (PST) </span>
                      </div>
                      <div className="col">
                        <span>Edition NFT Mint Price </span>
                      </div>
                      <div className="col">
                        <span>Number of NFT Editions </span>
                      </div>
                      <div className="col-1">
                        <span>Options</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    const UserImg = require(`../../../assets/${item.PersonImg}`);
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-3">
                            <img
                              src={UserImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <p className="mb-0 d-flex flex-column">
                              <span className="img-txt1">{item.FirstName}</span>
                              <span>{item.LastName}</span>
                            </p>
                          </div>
                          <div className="col">
                            <span>{item.Usertype}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.Email}</span>
                          </div>
                          <div className="col">
                            <span>{item.Twitter}</span>
                          </div>
                          <div className="col">
                            <span>{item.Insta}</span>
                          </div>
                          <div className="col">
                            <span>{item.TotalNFT}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--ENd Tabs --> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
